import { isEmptyString } from './common-util'
import water3 from 'assets/images/water-type03.png'

export const combineImages = async (menuImgUrl, aiImgYn, mainImgYn, uppderMark = false, moveYn = false) => {
  if (isEmptyString(menuImgUrl) || aiImgYn === 'N') {
    return null
  }

  try {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    const baseImage = new Image()
    const watermarkImage = new Image()

    baseImage.crossOrigin = 'anonymous'
    watermarkImage.crossOrigin = 'anonymous'

    baseImage.src = menuImgUrl
    watermarkImage.src = water3

    await Promise.all([
      new Promise((resolve) => (baseImage.onload = resolve)),
      new Promise((resolve) => (watermarkImage.onload = resolve)),
    ])

    canvas.width = baseImage.width
    canvas.height = baseImage.height

    const baseWidth = baseImage.width
    const baseHeight = baseImage.height

    // 워터마크 크기
    const watermarkScale = mainImgYn ? 0.8 : 0.5
    const watermarkWidth = baseWidth * watermarkScale
    const watermarkHeight = (watermarkImage.height / watermarkImage.width) * watermarkWidth

    // 패딩
    const paddingScale = baseWidth / 1024
    const paddingHorizontal = 30 * paddingScale
    const paddingVertical = 40 * paddingScale

    // 워터마크 위치
    let watermarkX = baseWidth - watermarkWidth - paddingHorizontal - (moveYn ? 10 : 0)
    let watermarkY = moveYn
      ? baseHeight - watermarkHeight - paddingVertical - 40
      : uppderMark
        ? paddingVertical
        : baseHeight - watermarkHeight - paddingVertical

    ctx.drawImage(baseImage, 0, 0) // 원본 이미지
    ctx.drawImage(watermarkImage, watermarkX, watermarkY, watermarkWidth, watermarkHeight) // 워터마크

    return canvas.toDataURL('image/jpeg')
  } catch (error) {
    console.error('이미지 합성 중 오류 발생:', error)
    return null
  }
}
